import { render, staticRenderFns } from "./insurance-table.vue?vue&type=template&id=266465e5&"
import script from "./insurance-table.vue?vue&type=script&lang=js&"
export * from "./insurance-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports